import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/font.css";
import "./styles/index.css";
import "./styles/tailwind.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'popper.js/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
